// extracted by mini-css-extract-plugin
export default {"SetupProviderHeader":"SetupProviderHeader_SetupProviderHeader__hptg7","CTAContainer":"SetupProviderHeader_CTAContainer__xyBaN"};